import type {Values} from "@wix/devzai-utils-common";
import {assertNotNullable, uiPartCreateNamespacedPartsGroups} from "@wix/devzai-utils-common";
import {elementClosest} from "@wix/devzai-utils-dom";

export const DoppePageViewerPart = {
    BymoSkipButton: 'BymoSkipButton',
    BrandAttribution: 'BrandAttribution'
} as const;

export type DoppePageViewerPart = Values<typeof DoppePageViewerPart>;

export const DoppePageViewerPartsGroups = uiPartCreateNamespacedPartsGroups('DoppePageViewerPartsGroup', {
    CloseButton: 'CloseButton',
    BackButton: 'BackButton',
});

const DoppePageViewerPartMarkingAttributeName = 'data-doppe-page-viewer-part';

export function doppePageViewerPartCreateMarkingAttributes (
    viewerPart: DoppePageViewerPart
) {
    return {
        [DoppePageViewerPartMarkingAttributeName]: viewerPart
    }
}

export function doppePageViewerPartGetFromElement (element: Element) {
    const partElement = elementClosest(element, `[${DoppePageViewerPartMarkingAttributeName}]`, true);
    if (partElement) {
        return assertNotNullable(partElement.getAttribute(DoppePageViewerPartMarkingAttributeName)) as DoppePageViewerPart;
    } else {
        return undefined;
    }
}